export default __webpack_public_path__ + "static/media/ring.f2985674.svg";